import React from 'react';

import Box from '@material-ui/core/Box';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Copyright from './furniture/Copyright'
import AppBarAndDrawer from './furniture/AppBarAndDrawer'
import {useStyles}from './furniture/Dashboard-Config'

import Stepper from './accountSelection/Stepper';
import { useOvermind } from '../overmind';

import NewSessionLoader from './accountSelection/NewSessionLoader'
import { Redirect } from 'react-router-dom';

export default function AccountSelection(){
  const classes = useStyles();
  const { state } = useOvermind();

  if(state.blockAccess && typeof state.authState.googleAccessToken ==='undefined'){
    return(<Redirect to='/'/>);
  }
  else if(state.blockAccess){
    //actions.updateFlag({'name':'redirectPath','payload':'/config'});
    return(<NewSessionLoader/>);
  }else{
    return (
      <div className={classes.root}>
        <AppBarAndDrawer/>

        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={2}>

              {/* Placeholder */}
              <Grid item xs={12} md={12} lg={12}>
                <Paper className={classes.paper}>
                    <Stepper />
                </Paper>
              </Grid>

            </Grid>
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  }
}
